export const ROOT = `/`;
export const NO_MATCHES = `*`;
export const LOGOUT = `/logout`;
export const PRIVATE_HIGHWAY = `/h`;

export const AUTH = {
  LOGIN: `/login`,
  REGISTER: `/register`,
  RESET_PASSWORD: `/reset-password`,
  USER_VALIDATION: `/user/validate/:token`,
  ORGANIZATION_ACCEPT_USER_INVITATION: `/organization/invitation/:token`,
  NEW_PASSWORD: `/user/new-password/:token`,
};

export const PLANNER = {
  ROOT: `/h/:projectId/planner`,
  PLANS: `/h/:projectId/planner/plans`,
  STOPS: {
    ROOT: `/h/:projectId/planner/stops`,
    LIST: `/h/:projectId/planner/stops/list`,
    MAP: `/h/:projectId/planner/stops/map`,
  },
  GEO_FENCES: `/h/:projectId/planner/geo-fences`,
  PLAN_DETAILS: {
    ROOT: `/h/:projectId/planner/plan/:planId`,
    OVERVIEW: `/h/:projectId/planner/plan/:planId/overview`,
    DRIVERS: `/h/:projectId/planner/plan/:planId/drivers`,
    STOPS: `/h/:projectId/planner/plan/:planId/stops`,
    EDIT: `/h/:projectId/planner/plan/:planId/edit`,
    SETTINGS: `/h/:projectId/planner/plan/:planId/settings`,
  },
};

export const PROJECT_SETTINGS = {
  ROOT: `/h/:projectId/project_settings`,
  GENERAL: `/h/:projectId/project_settings/general`,
  PLANNER_FIELDS: {
    ROOT: `/h/:projectId/project_settings/planner-fields`,
    CONSTRAINTS: `/h/:projectId/project_settings/planner-fields/constraints`,
    VEHICLES: `/h/:projectId/project_settings/planner-fields/vehicles`,
    CLIENTS: `/h/:projectId/project_settings/planner-fields/clients`,
  },
  TASKS_FIELDS: `/h/:projectId/project_settings/tasks-fields`,
  CUSTOM_FIELDS: `/h/:projectId/project_settings/custom-fields`,
  MEMBERS: `/h/:projectId/project_settings/members`,
  OPTIMIZER: `/h/:projectId/project_settings/optimizer`,
  PLANS: `/h/:projectId/project_settings/plans`,
  CLIENTS: {
    ROOT: `/h/:projectId/project_settings/clients`,
    LIST: `/h/:projectId/project_settings/clients/list`,
    MAP: `/h/:projectId/project_settings/clients/map`,
  },
  SUPERVISORS: {
    ROOT: `/h/:projectId/project_settings/supervisors`,
    LIST: `/h/:projectId/project_settings/supervisors/list`,
    STYLING: `/h/:projectId/project_settings/supervisors/styling`,
  },
};

export const PROJECT_ANALYTICS = {
  ROOT: `/h/:projectId/analytics`,
  SUMMARY: `/h/:projectId/analytics/summary`,
  PLANNER: {
    ROOT: `/h/:projectId/analytics/planner`,
    PLANS: `/h/:projectId/analytics/planner/plans`,
    ALL_STOPS: `/h/:projectId/analytics/planner/stops-status`,
    COMPLETED_STOPS: `/h/:projectId/analytics/planner/completed-stops`,
    INCOMPLETE_STOPS: `/h/:projectId/analytics/planner/incomplete-stops`,
    CANCELED_STOPS: `/h/:projectId/analytics/planner/canceled-stops`,
    DELIVERY_TIME: `/h/:projectId/analytics/planner/delivery-schedule`,
    PROOF_OF_DELIVERY: `/h/:projectId/analytics/planner/proof-of-delivery`,
    CANCELLATION_REASONS: `/h/:projectId/analytics/planner/cancellation-reasons`,
    // STOPS_PER_ZONE: `/h/:projectId/analytics/stops-per-zone`,
  },
  DRIVERS: {
    ROOT: `/h/:projectId/analytics/drivers`,
    TIME_ON_ROUTE: `/h/:projectId/analytics/drivers/time-on-route`,
    DELIVERY_DELAYS: `/h/:projectId/analytics/drivers/delivery-delays`,
    ROUTE_TRACKING: `/h/:projectId/analytics/drivers/route-tracking`,
    DELIVERY_ATTEMPTS: `/h/:projectId/analytics/drivers/delivery-attempts`,
    SATISFACTION: `/h/:projectId/analytics/drivers/satisfaction`,
  },
  CUSTOMERS: {
    ROOT: `/h/:projectId/analytics/customers`,
    SATISFACTION: `/h/:projectId/analytics/customers/satisfaction`,
    SENT_SMS: `/h/:projectId/analytics/customers/sent-sms`,
    SENT_EMAILS: `/h/:projectId/analytics/customers/sent-emails`,
  },
};

export const DRIVERS = {
  ROOT: `/h/:projectId/drivers`,
  VEHICLES: `/h/:projectId/drivers/vehicles`,
  APP: {
    ROOT: `/h/:projectId/drivers/app`,
    CONFIGURATION: `/h/:projectId/drivers/app/configuration`,
    STOP_FIELDS: `/h/:projectId/drivers/app/stop-fields`,
  },
  POD: {
    ROOT: `/h/:projectId/drivers/pod`,
    COMPLETED: `/h/:projectId/drivers/pod/completed`,
    CANCELED: `/h/:projectId/drivers/pod/canceled`,
  },
};

export const CUSTOMERS = {
  ROOT: `/h/:projectId/customers`,
  NOTIFICATIONS: {
    ROOT: `/h/:projectId/customers/notifications`,
    EMAILS: `/h/:projectId/customers/notifications/emails`,
    SMS: `/h/:projectId/customers/notifications/sms`,
  },
  APP: `/h/:projectId/customers/app`,
  STYLING: `/h/:projectId/customers/styling`,
};

export const NO_PROJECTS = `/h/no_projects`;

export const COOKIES_POLICY = `https://routal.com/politica-de-cookies/`;

export const EXTERNAL = {
  DOCS: `https://support.routal.com/`,
  LANDING: `https://routal.com/`,
};

export const SETTINGS = {
  ROOT: `/h/settings`,
  ACCOUNT: {
    ROOT: `/h/settings/account`,
    PROFILE: `/h/settings/account/profile`,
  },
  ORGANIZATION: {
    ROOT: `/h/settings/organization`,
    PROFILE: `/h/settings/organization/profile`,
    USERS: `/h/settings/organization/users`,
    PROJECTS: `/h/settings/organization/projects`,
  },
  BILLING: {
    ROOT: `/h/settings/billing`,
    SUBSCRIPTION: `/h/settings/billing/subscription`,
    INVOICES: `/h/settings/billing/invoices`,
  },
  DEVELOPERS: {
    ROOT: `/h/settings/developers`,
    API_KEYS: `/h/settings/developers/api-keys`,
    WEBHOOKS: `/h/settings/developers/webhooks`,
  },
};

export const BACKOFFICE = {
  ROOT: `/h/backoffice`,
  CLIENTS: {
    ROOT: `/h/backoffice/clients`,
    USERS: `/h/backoffice/clients/users`,
    ORGANIZATIONS: `/h/backoffice/clients/organizations`,
    PROJECTS: `/h/backoffice/clients/projects`,
  },
  ACQUISITION: `/h/backoffice/acquisition`,
  USAGE: `/h/backoffice/usage`,
  TRANSLATIONS: `/h/backoffice/translations`,
};
